// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"6f826c34","462":"165b7e0b"}[chunkId] + ".chunk.js";
};